<template>
  <img :src="thumbImage" />
</template>

<script lang="ts">
import { defineComponent, computed, unref } from "vue";
import { resourceThumb } from "~/lib/thumbs";
import { useYukiDataStore } from "~/stores";

export default defineComponent({
  name: "ResourceThumb",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    return {
      thumbImage: computed(() => {
        const dataStore = useYukiDataStore();
        const resource = dataStore.resources.get(props.id);
        return unref(resourceThumb(resource?.art_id || props.id));
      }),
    };
  },
});
</script>
